<template>
  <component
    :is="chart"
    ref="chart"
  />
</template>

<script>
import VueCharts from 'vue-chartjs'

export default {
  props: {
    chartType: {
      type: String,
      required: true
    },
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: false,
      default: () => { return null }
    }
  },
  computed: {
    chart () {
      return VueCharts[this.translateToActualChartType(this.chartType)]
    }
  },
  mounted () {
    this.$refs['chart'].renderChart(this.chartData, this.options)
  },
  methods: {
    translateToActualChartType (chartType) {
      switch (chartType) {
        case 'Area': {
          return 'Line'
        }
        default: {
          return chartType
        }
      }
    },
    refresh () {
      this.$refs['chart'].renderChart(this.chartData, this.options)
    }
  }
}
</script>
